rjm.ui.ChartBuilderTimeOptionsView = rjm.ui.ChartBuilderDropdownView.extend(
  id: "cbTime"
  className: "span"

  events:
    "click .quickLink": "quickLinkHandler"
    "click button": "render"

  initialize: (options) ->
    if not options or not options.chartModel or not options.viewState
      throw "InvalidConstructorArgs - ChartBuilderTimeOptionsView"

    _.bindAll this, "quickLinkHandler", "getCalendarIntervalNamesForLinks", "getDayIntervalNamesForLinks", "getOtherIntervalNamesForLinks", "convertDateRangeToDateString", "getTimePeriodDescription", "generateTemplateData", "toggleAllTimeQuickLink", "toggleQuickLinkSelection", "setActiveTabs", "setActiveLinks", "enablePopover", "disablePopover", "handleExternalClickEvent", "render"
    @chartModel = options.chartModel
    @timeFrame = @chartModel.get('timeFrame')
    @viewState = options.viewState

    @listenTo @chartModel.getCurrentSeries(), "change:trend", @render
    @listenTo @chartModel, "change:api_conn_id", @block
    @listenTo @chartModel.getCurrentSeries(), "change:trend", ->
      if @chartModel.hasTimestamp()
        @unblock()
    # we don't want to allow users to change the time frame when the perspective in incremental event probablity
    @listenTo @chartModel.getCurrentSeries(), "change:dataPerspective", (series, dataPerspective) ->
      if dataPerspective is rjm.app.enums.dataPerspective.INC_EVENT_PROB
        @block()
      else 
        @unblock()
  
    return

  quickLinkHandler: (e) ->
    e.preventDefault()

    #do not handle clicks on quicklinks that are disabled
    if @$(e.target).hasClass("disabled") or @$(e.target).parent().hasClass("disabled")
      return

    type = $(e.target).data("type")
    enumId = $(e.target).data("id")
    count = $(e.target).data("count")
    includeLastPeriod = $(e.target).data("include")
    intervalObj = rjm.app.enums.timeInterval[enumId]
    typeObj = rjm.app.enums.timeFrameType[type]

    #we are looking at a moving time frame
    if typeObj is rjm.app.enums.timeFrameType.MOVING
      @timeFrame.set
        excludeInterval: intervalObj
        includeInterval: intervalObj
        excludePeriodCount: if includeLastPeriod? and includeLastPeriod then 0 else 1
        includePeriodCount: 1 + count
        type: rjm.app.enums.timeFrameType.MOVING
    
    #we are looking at an all time frame
    if typeObj is rjm.app.enums.timeFrameType.ALL_TIME
      @timeFrame.set
        type: rjm.app.enums.timeFrameType.ALL_TIME

    #check to see if the current time Interval is greater than the new time period (interval * repitition). If it is use the new time interval
    if @chartModel.get('timeInterval')?.secondsInInterval >= intervalObj?.secondsInInterval * count
      @chartModel.set
        timeInterval: intervalObj

    @render()
    return

  getCalendarIntervalNamesForLinks: ->
    intervals = _(rjm.app.enums.timeInterval).filter((item) ->
                  item isnt rjm.app.enums.timeInterval.HOUR and item isnt rjm.app.enums.timeInterval.SECOND and item isnt rjm.app.enums.timeInterval.DAY
                ).map((value) ->
                  type: rjm.app.enums.timeFrameType.MOVING.serializedValue
                  name: "Last " + value.names
                  value: value.serializedValue
                  count: 1
                )
    #Add the special case of 'Last 2 Weeks'
    intervals.push
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Last 2 Weeks"
      value: rjm.app.enums.timeInterval.WEEK.serializedValue
      count: 2
    
    return intervals

  getDayIntervalNamesForLinks: ->

    intervals = [
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Last 7 Days" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 7
    ,
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Last 14 Days" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 14
    ,
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Last 30 Days" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 30
    ,
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Last 90 Days" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 90
    ,
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Last 365 Days" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 365
    ]

  getOtherIntervalNamesForLinks: ->

    intervals = [
      type: rjm.app.enums.timeFrameType.ALL_TIME.serializedValue
      name: "All-Time"
    ,
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Today" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 0
      includeLastPeriod: true
    ,
      type: rjm.app.enums.timeFrameType.MOVING.serializedValue
      name: "Yesterday" 
      value: rjm.app.enums.timeInterval.DAY.serializedValue 
      count: 1
      includeLastPeriod: false
    ]

  convertDateRangeToDateString: ->
    dateRange = @timeFrame.convertRangeToDateObjects()
    start = dateRange.start.toString("ddd MMM dd, yyyy HH:mm");
    end = dateRange.end.toString("ddd MMM dd, yyyy HH:mm");
    
    #start and end is within the same day so we must be spanning a single day
    if dateRange.start.toString("MMM dd yyyy") is dateRange.end.addSeconds(-1).toString("MMM dd yyyy")
      return "#{dateRange.start.toString("ddd MMM dd, yyyy")}"
    #the chart is up to now if today (at midnight) is less than the end date
    else if Date.today() < dateRange.end 
      end = 'now';

    return "#{start}</br>to</br>#{end}" #11 spaces to get it to look nice

  getTimePeriodDescription: ->
    switch @timeFrame.get("type")
      when rjm.app.enums.timeFrameType.MOVING
        #special cases of Yesterday and Today
        if @timeFrame.get('excludePeriodCount') is 1 and @timeFrame.get('includePeriodCount') is 2 and @timeFrame.get('includeInterval') is @timeFrame.get('excludeInterval') and @timeFrame.get('includeInterval') is rjm.app.enums.timeInterval.DAY
          return (
            timePeriodDescription: "Yesterday"
            helpText: "over"
          )
        if @timeFrame.get('excludePeriodCount') is 0 and @timeFrame.get('includePeriodCount') is 1 and @timeFrame.get('includeInterval') is @timeFrame.get('excludeInterval') and @timeFrame.get('includeInterval') is rjm.app.enums.timeInterval.DAY
          return (
            timePeriodDescription: "Today"
            helpText: "over"
          )
        # "Last interval" case
        if @timeFrame.get('excludePeriodCount') is 1 and @timeFrame.get('includePeriodCount') is 2 and @timeFrame.get('includeInterval') is @timeFrame.get('excludeInterval')
          return (
            timePeriodDescription: "Last #{@timeFrame.get('includeInterval').names}"
            helpText: "over the"
          )
        # "Last n intervals" case
        if @timeFrame.get('excludePeriodCount') is 1 and @timeFrame.get('includeInterval') is @timeFrame.get('excludeInterval')
          return (
            timePeriodDescription: "Last #{@timeFrame.get('includePeriodCount')-1} #{@timeFrame.get('includeInterval').names}s"
            helpText: "over the"
          )
        # For all other cases we need to spell them out
        return (
          timePeriodDescription: "#{@timeFrame.get('includePeriodCount')} #{@timeFrame.get('includeInterval').names}(s) ago, to #{@timeFrame.get('excludePeriodCount')} #{@timeFrame.get('excludeInterval').names}(s) ago." 
          helpText: "from"
        )
      when rjm.app.enums.timeFrameType.SPECIFIC
        if not _(@timeFrame.get("start")).isDate() and not _(@timeFrame.get("end")).isDate()          
          return (
            timePeriodDescription: "All-Time"
            helpText: "over"
          )  
        start = (if (_(@timeFrame.get("start")).isDate()) then @timeFrame.get("start").toDateString() else "oldest available date")
        end = (if (_(@timeFrame.get("end")).isDate()) then @timeFrame.get("end").toDateString() else "now")
        return (
          timePeriodDescription: "#{start} to #{end}"
          helpText: (if (_(@timeFrame.get("start")).isDate()) then "from" else "from the")
        )
              
      when rjm.app.enums.timeFrameType.ALL_TIME 
        return (
          timePeriodDescription: "All-Time"
          helpText: "over"
        )
  generateTemplateData: ->
    {timePeriodDescription, helpText} = @getTimePeriodDescription()
    return (
      timeFrames: rjm.app.enums.timeFrameType
      otherIntervalNamesForLinks: @getOtherIntervalNamesForLinks()
      calendarIntervalNamesForLinks: @getCalendarIntervalNamesForLinks()
      dayIntervalNamesForLinks: @getDayIntervalNamesForLinks()
      framePropertyName: "names"
      currentTimeFrame: @timeFrame.get("type").serializedValue

      timePeriodDescription: timePeriodDescription
      helpText: helpText
    )
  #activate/deactivate the all-time quicklink
  toggleAllTimeQuickLink: (active) ->
    @$("li > a[data-type=ALL_TIME]").parent().toggleClass("active", active)

  #activate/deactivate the appropriate quicklink based on the current model (excluding all-time)
  toggleQuickLinkSelection: (active) ->
    quickLinkElement = null
    includeInterval = @timeFrame.get('includeInterval')?.serializedValue
    excludeInterval = @timeFrame.get('excludeInterval')?.serializedValue
    includePeriodCount = @timeFrame.get('includePeriodCount')
    excludePeriodCount = @timeFrame.get('excludePeriodCount')
    if(excludePeriodCount is 0)
      quickLinkElement = @$("li > a[data-type=MOVING][data-id=#{includeInterval}][data-count=#{includePeriodCount - 1}][data-include=true]")
    else
      quickLinkElement = @$("li > a[data-type=MOVING][data-id=#{includeInterval}][data-count=#{includePeriodCount - 1}]")

    if(includeInterval is excludeInterval and excludePeriodCount <= 1 and quickLinkElement.length != 0)
      #make the appropriate quick link active
      quickLinkElement.parent().toggleClass("active", active)
      return true

    return false

  #activate/deactivate the moving/specific tab(s)
  setActiveTabs: (moving, specific) ->
    @$(".customInterval").parent().toggleClass("active", moving)
    @$("#customInterval").toggleClass("active", moving)
    @$(".dateRange").parent().toggleClass("active", specific)
    @$("#dateRange").toggleClass("active", specific)

  #sets the appropriate links as active based on the current model state
  setActiveLinks: ->
    @setActiveTabs false, false
    switch @timeFrame.get("type")
      when rjm.app.enums.timeFrameType.MOVING
        if not @toggleQuickLinkSelection true
          #make the moving date range tab active  
          @setActiveTabs true, false
      when rjm.app.enums.timeFrameType.SPECIFIC
        #make the specific date range tab active
        @setActiveTabs false, true
      when rjm.app.enums.timeFrameType.ALL_TIME
        #make the All-Time quick link active and deactivate all tabs
        @toggleAllTimeQuickLink true
        @setActiveTabs false, false
        
  enablePopover: ->
    switch @timeFrame.get("type")
      when rjm.app.enums.timeFrameType.MOVING
        @$("a.timePeriod").popover
          trigger: 'hover'
          title: 'Exact Time Span'
          container: 'body'
          content: @convertDateRangeToDateString()
          placement: 'bottom'
          html: true

  disablePopover: ->
    @$("a.timePeriod").popover 'destroy'

  handleExternalClickEvent: (e) ->
    rjm.ui.ChartBuilderDropdownView.prototype.handleExternalClickEvent.call(this, e);
    @enablePopover()
    return

  render: ->

    #adjust the time frame to something other than all-time
    if @chartModel.isGAChart() and @timeFrame.get("type") is rjm.app.enums.timeFrameType.ALL_TIME 
      @timeFrame.setDefaultGATimeOptions()

    @$el.html ich.chartBuilderTimeOptions(@generateTemplateData())

    #set or remove the dropdown label
    @enablePopover()


    # This is to get the timeperiod Dropdown to work correctly. Doing it with bootstrap kills it no matter where you click.
    # There should be a better way of doing this.
    $('.btn.dropdown-toggle.timePeriod span').on('click', (e) =>
      e.preventDefault()
      $(e.target).parent().trigger('click')
      @disablePopover()
    )

    $('.btn.dropdown-toggle.timePeriod').on('click', (e) =>
      e.preventDefault()
      $(e.target).find('~.dropdown-menu').toggle()

      #set the ui tab elements appropriately
      @setActiveLinks()

      #render specific date range options
      @specificTimeOptions = new rjm.ui.ChartBuilderTimeOptionsSpecificView(
        timeFrameModel: @timeFrame
        chartModel: @chartModel
        el: @$("#dateRange")
      ).render()

      #render moving date range options
      @movingTimeOptions = new rjm.ui.ChartBuilderTimeOptionsMovingView(
        timeFrameModel: @timeFrame
        el: @$("#customInterval")
      ).render()
      @disablePopover()
    )

    #set quicklinks to inactive when custom or specific data range is selected
    $('.customInterval').on('click', (e) =>
      @toggleQuickLinkSelection false
      @toggleAllTimeQuickLink false
    )

    $('.dateRange').on('click', (e) =>
      @toggleQuickLinkSelection false
      @toggleAllTimeQuickLink false
    )

    #GA charts do not support ALL TIME
    if @chartModel.isGAChart()
      @$('a[data-type=ALL_TIME]').parent().addClass('disabled')

    if @chartModel.isGAChart() and not @chartModel.getCurrentSeries().get("trend").isGATrend()
      @block()
    else unless @chartModel.hasTimestamp()
      @$("#dateRangeDescription").addClass("label").html('No timestamp column set on trend')
      @block()
    else if @chartModel.getCurrentSeries().get("dataPerspective") is rjm.app.enums.dataPerspective.INC_EVENT_PROB
      @block()
    else  
      @unblock()
    
    return @
)